import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Insights from "@/pages/Insights";
import Article from "@/pages/Article";
import { Seo, ROUTE_SEO } from "@/components/Seo";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  const meta = ROUTE_SEO[pathname];
  return meta ? <Seo title={meta.title} description={meta.description} image={meta.image} /> : null;
};

function App() {
  return (
    <div className="App grain font-body">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <RouteSeo />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/content" element={<Navigate to="/insights" replace />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<Article />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }} />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
